<template>
  <div class="p-4">
    <SmartSelect
      v-model="form.device"
      :options="availableDevices"
      display-field="name"
      value-field="id"
      value-type="string"
      placeholder="请选择设备"
      class="w-64"
    />
    <div class="mt-4 flex gap-2">
      <el-button type="primary" @click="showSelected">显示选中数据</el-button>
      <el-button @click="setSelected('2')">只选Device B</el-button>
      <el-button @click="setSelected('1')">只选Device A</el-button>
      <el-button @click="setSelected('')">清空选择</el-button>
    </div>
  </div>
</template>

<script>
import SmartSelect from "@/components/SmartControls/SmartSelect.vue";
export default {
  name: "SmartSelectPage",
  components: {
    SmartSelect,
  },
  data() {
    return {
      availableDevices: [
        { id: "1", name: "Device A", type: "Type 1" },
        { id: "2", name: "Device B", type: "Type 2" },
        { id: "3", name: "Device C", type: "Type 3" },
      ],
      form: {
        device: "1",
      },
    };
  },
  methods: {
    showSelected() {
      const selected = this.availableDevices.find(
        (d) => d.id === this.form.device
      );
      this.$alert(
        `<pre>${JSON.stringify(selected, null, 2)}</pre>`,
        "选中数据",
        {
          dangerouslyUseHTMLString: true,
        }
      );
    },
    setSelected(id) {
      this.form.device = id;
    },
  },
};
</script>